import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import api from "../config/axios";
import CreatePostSection from "../components/AppHome/CreatePostSection";
import SecondSectionAppHome from "../components/AppHome/SecondSectionAppHome";
import ThirdSectionAppHome from "../components/AppHome/ThirdSectionAppHome";
import FourthSectionAppHome from "../components/AppHome/FourthSectionAppHome";
import AppRightSidebar from "../components/AppRightSidebar";

function AppHome() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchAllPosts();
  }, []);

  const fetchAllPosts = async () => {
    try {
      const res = await api.get("/posts");
      console.log("API Response for Posts:", res.data);
      setPosts(res.data);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  // Called when a new post is created
  const handlePostCreated = (newPost) => {
    console.log("New Post Created:", newPost);
    setPosts((prev) => [newPost, ...prev]);
  };

  // Called when a post is updated (like, share, comment)
  const handlePostUpdate = (updatedPost) => {
    console.log("Post Updated:", updatedPost);
    setPosts((prevPosts) =>
      prevPosts.map((post) => (post._id === updatedPost._id ? updatedPost : post))
    );
  };

  return (
    <Stack
      id="app-home-container"
      direction="row"
      spacing={1.5}
      sx={{ justifyContent: "space-between" }}
    >
      <Stack
        sx={{
          width: "100%",
          minWidth: "68%",
        }}
        spacing={2}
      >
        <CreatePostSection onPostCreated={handlePostCreated} />
        <SecondSectionAppHome posts={posts} onPostUpdate={handlePostUpdate} />
        {/* <ThirdSectionAppHome /> */}
        {/* <FourthSectionAppHome /> */}
      </Stack>
      <AppRightSidebar />
    </Stack>
  );
}

export default AppHome;
